<template>
  <div class="myUnderstand_wrap">
    <myHeader />
    <div class="content">
      <!-- 文本模块 -->
      <div class="text">
        <div class="layout_text">
          <p class="wow fadeInUp" style="color: #b3b3b3; font-size: 24px">
            What is 2.5D?
          </p>
          <p class="wow fadeInUp" style="font-size: 48px; margin: 20px 0 60px">
            Discover how 2.5D brings your projects to life
          </p>
          <p
            class="default_font wow fadeInUp"
            style="
              font-size: 20px;
              font-weight: 400;
              line-height: 30px;
              letter-spacing: 1px;
            "
          >
            2.5D refers to a scene-building approach that combines 2D and 3D
            assets. It uses multiple layers of images or dynamic scene content
            with transparent channels to create visual elements of different
            depths, including foreground,midground, and background layers.<br />
            When shooting scenes with specific camera movements, 2.5D
            significantly reduces the complexity of production compared to fully
            3D environments, while remaining compatible with existing 3D
            workflows. For teams engaged in labor-intensive 3D scene creation,
            it offers a more economical and efficient alternative
          </p>
          <p
            class="wow fadeInUp"
            style="color: #fff; font-size: 24px; margin: 40px 0 50px"
          >
            Overlay Rendering Output
          </p>
        </div>
      </div>
      <div class="layout_text">
        <div class="img wow fadeInUp">
          <img style="width: 100%" src="https://download.hecoos.com/enlightv/2025-17/b6cf8fdfe1dd71abde278bc0ff977fdb.png" alt="" />
        </div>
      </div>
      <!-- 位置关系模块 -->
      <div class="layout_text">
        <div class="position_module">
          <p
            class="wow fadeInUp"
            style="color: #fff; font-size: 24px; margin: 40px 0 60px"
          >
            Positional Relationships of Different Scene Layers During Camera
            Movement
          </p>
          <img
            class="wow fadeInUp"
            style="width: 100%; margin-bottom: 50px"
            src="https://download.hecoos.com/enlightv/2025-17/609dde8ae74ce6247067775d338ace9d.png"
            alt=""
          />
          <img
            class="wow fadeInUp"
            style="width: 100%"
            src="https://download.hecoos.com/enlightv/2025-17/5175ff6161aabf86f6b983bf95ed54e6.png"
            alt=""
          />
        </div>
      </div>

      <!-- AIGC模块 -->
      <div class="layout_text">
        <div class="aigc_module">
          <div>
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 48px; margin: 0 0 10px"
            >
              AIGC + 2.5D
            </p>
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 36px; margin: 0 0 30px"
            >
              Significantly Enhance Scene Construction Efficiency in Virtual
              Production
            </p>
          </div>
          <div class="aigc">
            <div class="aigc_text">
              <p
                class="wow fadeInUp"
                style="font-size: 24px; line-height: 36px; width: 93%"
              >
                Deconstruct and segment 2D scene images or dynamic scene content
                generated by AIGC, then recombine them into layered 2.5D assets
                for live shooting with hecoos xR/VP.
              </p>
            </div>
            <img
              class="wow fadeInUp"
              style="width: 50%; display: block"
              src="https://download.hecoos.com/enlightv/2025-17/0a5e958a0e994e2674250d8115e2decd.png"
              alt=""
            />
          </div>
          <img
            class="wow fadeInUp"
            style="width: 100%"
            src="https://download.hecoos.com/enlightv/2025-17/f07b77034904190b108474709a5ea7d4.png"
            alt=""
          />
        </div>
      </div>

      <!-- 快~~模块 -->
      <div class="layout_text">
        <div class="fast_module">
          <div class="fast_left">
            <img
              class="wow fadeInUp"
              width="3%"
              style="margin-bottom: 24px"
              src="https://download.hecoos.com/enlightv/2025-17/89a7106ac2dfbc5930a584a7ffbbd1d1.png"
              alt=""
            />
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 48px; margin: 14px 0 20px"
            >
              Sharp as ever
            </p>
            <p class="wenB wow fadeInUp">
              hecoos xR/VP 2.5D Shooting Solution enables users to quickly
              modify and adjust virtual scenes using AIGC content generation
              capabilities, whether during the early creative production phase
              or throughout the filming process. This approach reduces reliance
              on 3D asset teams, allowing for the rapid transformation of
              concepts into specific shot scenes within minutes, leading to a
              more flexible, efficient, and cost-effective creative process.
            </p>
            <img
              class="wow fadeInUp"
              style="width: 80%"
              src="https://download.hecoos.com/enlightv/2025-17/44f416980b378e5e3a5877efafa856b6.png"
              alt=""
            />
          </div>
          <div class="fast_rig">
            <img
              class="wow fadeInUp"
              width="5%"
              style="margin-bottom: 24px"
              src="https://download.hecoos.com/enlightv/2025-17/49d11a36b1591c6e90891e75e8d806c9.png"
              alt=""
            />
            <p
              class="wow fadeInUp"
              style="color: #fff; font-size: 48px; margin: 14px 0 20px"
            >
              Focus on Actionability
            </p>
            <p class="wenB wow fadeInUp">
              hecoos xR/VP 2.5D Shooting Solution enables users to quickly
              modify and adjust virtual scenes using AIGC content generation
              capabilities, whether during the early creative production phase
              or throughout the filming process. This approach reduces reliance
              on 3D asset teams, allowing for the rapid transformation of
              concepts into specific shot scenes within minutes, leading to a
              more flexible, efficient, and cost-effective creative process.
            </p>
            <img
              class="wow fadeInUp"
              style="width: 80%"
              src="https://download.hecoos.com/enlightv/2025-17/ff121c939c5b6ceaf87334996c109a5d.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import BackToTop from "@/components/en_pc/BackToTop";
export default {
  components: {
    myHeader,
    myFooter,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
</style>